module.exports = __webpack_public_path__ + "assets/img/vNoteIcon.496e64cc.svg";